import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {rutValidate} from 'rut-helpers';

export function forbiddenRut(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return !rutValidate(control.value) ? {rutInvalido: 'Ingrese un rut valido'} : null;
  };
}
